import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { dangerColor, warnTextColor } from '../../../lib/theme';
import { SMS_BODY_MAX, getSmsSegmentInfo } from '../../../lib/helpers/sms.helpers';

interface ISmsCharacterCounterProps {
  value: string;
}

export const SmsCharacterCounter: React.FC<ISmsCharacterCounterProps> = ({ value }) => {
  const info = getSmsSegmentInfo(value);
  const multiSegment = info.segments > 1;
  const countColor = info.overLimit ? dangerColor : multiSegment ? warnTextColor : undefined;

  let guidance = '';
  if (multiSegment) {
    guidance = `Sends as ${info.segments} segments — keep under ${info.singleSegmentMax} for a single SMS`
      + (info.encoding === 'Unicode' ? ' (Unicode)' : '');
  } else if (info.length > 0) {
    guidance = `Single SMS${info.encoding === 'Unicode' ? ' (Unicode)' : ''}`;
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="baseline" mt={0.5} gridGap={8}>
      <Typography variant="caption" style={{ color: multiSegment ? warnTextColor : undefined }}>
        {guidance}
      </Typography>
      <Typography variant="caption" style={{ color: countColor, flexShrink: 0 }}>
        {info.length} / {SMS_BODY_MAX}
      </Typography>
    </Box>
  );
};
